export default {
    locale: window.appConfig.locale ? window.appConfig.locale : "ru",
};
